import { useState } from "react"
import { useTranslations, useBootstrap } from "../../lib/translations"
import { useStore } from "../../stores/store"
import { companyStore } from "../../stores/companyStore"
import { canvasStore, setSearch } from "../../stores/canvasStore"
import { api } from "../../lib/api"
import { GithubPill } from "./GithubPill"

function Logo() {
  return (
    <div className="cm-logo">
      <svg viewBox="0 0 24 24">
        <path d="M12 2l2.4 5.3L20 8l-4 4 1 6-5-2.8L7 18l1-6-4-4 5.6-.7L12 2z" />
      </svg>
    </div>
  )
}

function CompanyPicker() {
  const t = useTranslations()
  const bootstrap = useBootstrap()
  const { current, memberships } = useStore(companyStore)
  const [open, setOpen] = useState(false)

  if (!current) return null

  const select = async (companyId) => {
    if (companyId === current.id) return setOpen(false)
    await api.post(bootstrap.paths.select_company, { company_id: companyId })
    window.location.reload()
  }

  return (
    <div className="cm-company" onClick={() => setOpen(!open)} title={t("shell.company_picker.label")}>
      <span className="dot" />
      <span>{current.name}</span>
      <svg viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z" /></svg>
      {open && (
        <div className="cm-company-menu" onClick={(e) => e.stopPropagation()}>
          {memberships.map((m) => (
            <div key={m.company_id}
                 className={`cm-company-menu-item ${m.company_id === current.id ? "active" : ""}`}
                 onClick={() => select(m.company_id)}>
              {m.company_name}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function Search() {
  const t = useTranslations()
  const search = useStore(canvasStore, (s) => s.search)
  return (
    <div className="cm-search">
      <svg viewBox="0 0 24 24">
        <path d="M10 2a8 8 0 105.3 14l5.4 5.4 1.4-1.4-5.4-5.4A8 8 0 0010 2zm0 2a6 6 0 110 12 6 6 0 010-12z" />
      </svg>
      <input value={search} onChange={(e) => setSearch(e.target.value)}
             placeholder={t("canvas.search.placeholder")} />
      <kbd>{t("canvas.search.kbd_hint")}</kbd>
    </div>
  )
}

function ThemeToggle() {
  const t = useTranslations()
  const [dark, setDark] = useState(document.documentElement.getAttribute("data-theme") === "dark")
  const toggle = () => {
    const next = dark ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    localStorage.setItem("cm:theme", next)
    setDark(!dark)
  }
  return (
    <div className="cm-iconbtn" onClick={toggle} title={t("shell.theme.toggle")}>
      {dark ? (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M12 7a5 5 0 100 10 5 5 0 000-10zM12 1v3M12 20v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M1 12h3M20 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24">
          <path d="M12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36A6 6 0 0112 3z" />
        </svg>
      )}
    </div>
  )
}

function SignOut() {
  const t = useTranslations()
  const bootstrap = useBootstrap()
  const submit = () => {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = bootstrap.paths.sign_out
    form.style.display = "none"
    const csrf = document.createElement("input")
    csrf.name = "authenticity_token"; csrf.value = bootstrap.csrf_token; form.appendChild(csrf)
    const method = document.createElement("input")
    method.name = "_method"; method.value = "delete"; form.appendChild(method)
    document.body.appendChild(form); form.submit()
  }
  return (
    <div className="cm-iconbtn" onClick={submit} title={t("shell.sign_out")}>
      <svg viewBox="0 0 24 24"><path d="M10 17l-1.4-1.4 2.6-2.6H3v-2h8.2L8.6 8.4 10 7l5 5-5 5zm9-13H12V2h7c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2h-7v-2h7V4z"/></svg>
    </div>
  )
}

function UserAvatar() {
  const bootstrap = useBootstrap()
  return <div className="cm-me" title={bootstrap.user?.email}>{bootstrap.user?.initials || "?"}</div>
}

export function Header() {
  return (
    <header className="cm-header">
      <div className="cm-brand">
        <Logo />
        <div>
          <b>CrewMagic</b>
          <small>bento warm</small>
        </div>
      </div>
      <CompanyPicker />
      <Search />
      <div className="cm-tools">
        <GithubPill />
        <ThemeToggle />
        <SignOut />
        <UserAvatar />
      </div>
    </header>
  )
}
